import { MaintenanceForm } from '@/maintenance/MaintenanceForm'

export function Maintenance() {
  return <MaintenanceForm />
}
